module.exports = __webpack_public_path__ + "static/media/business_mode.828eaa22.png";